import React from 'react';
import { ButtonToolbar } from 'reactstrap';
import PropTypes from 'prop-types';
import MaintenanceServiceOrderEditButton from './MaintenanceServiceOrderEditButton';
import MaintenanceServiceOrderAssignExecutionButton from './MaintenanceServiceOrderAssignExecutionButton';
import MaintenanceServiceOrderPrintButton from './MaintenanceServiceOrderPrintButton';
import MaintenanceServiceOrderDeleteButton from './MaintenanceServiceOrderDeleteButton';
import ChangeMaintenanceServiceOrderStatusButton from './ChangeMaintenanceServiceOrderStatusButton';

const MaintenanceServiceOrderToolbar = ({
  maintenanceServiceOrderId,
  currentStatus,
}) => (
  <ButtonToolbar className="pull-right">
    <div>
      <MaintenanceServiceOrderAssignExecutionButton
        maintenanceServiceOrderId={maintenanceServiceOrderId}
      />{' '}
      <ChangeMaintenanceServiceOrderStatusButton
        maintenanceServiceOrderId={maintenanceServiceOrderId}
        currentStatus={currentStatus}
        refreshServiceOrder
      />{' '}
      <MaintenanceServiceOrderPrintButton />{' '}
      <MaintenanceServiceOrderEditButton
        maintenanceServiceOrderId={maintenanceServiceOrderId}
      />{' '}
      <MaintenanceServiceOrderDeleteButton
        maintenanceServiceOrderId={maintenanceServiceOrderId}
      />
    </div>
  </ButtonToolbar>
);

MaintenanceServiceOrderToolbar.propTypes = {
  maintenanceServiceOrderId: PropTypes.number.isRequired,
  currentStatus: PropTypes.string.isRequired,
};

export default MaintenanceServiceOrderToolbar;
